module.exports = __webpack_public_path__ + "img/aopumai_wx.78563e9d.png";